module.exports = __webpack_public_path__ + "img/dcim.e8983cfc.jpg";